import { Api } from '@allswipes/client';

/**
 * Единственный экземпляр клиента на приложение.
 *
 * Базовый URL пустой: Vite в разработке проксирует /api на Go, в бою фронтенд
 * и API живут на одном origin. Это убирает CORS и делает dev похожим на прод.
 */
export const api = new Api(import.meta.env.VITE_API_URL ?? '', 'allswipes-app-token');
